function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import PropTypes from 'prop-types';
import defaultProps from '../default-props';

const UndrawExploring = _props => {
  const props = Object.assign({}, _props);
  const primaryColor = props.primaryColor || defaultProps.primaryColor;
  const style = Object.assign({
    height: props.height || defaultProps.height,
    width: '100%'
  }, props.style);
  delete props.primaryColor;
  delete props.height;
  delete props.style;
  return React.createElement("svg", _extends({
    "data-name": "Layer 1",
    width: "1em",
    height: "1em",
    viewBox: "0 0 1089.05 792.04",
    style: style
  }, props), React.createElement("defs", null, React.createElement("linearGradient", {
    id: "prefix__a",
    x1: 363.23,
    y1: 724.55,
    x2: 363.23,
    y2: 134.03,
    gradientTransform: "matrix(-1 0 0 1 828.87 0)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.25
  }), React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), React.createElement("linearGradient", {
    id: "prefix__b",
    x1: 646.9,
    y1: 676.21,
    x2: 646.9,
    y2: 530.17,
    xlinkHref: "#prefix__a"
  })), React.createElement("path", {
    d: "M604.86 382.02a141.82 141.82 0 0 0-75.07 21.37 142.43 142.43 0 0 0-142.42-141.37 142.06 142.06 0 0 0-49.64 8.9v-34.47A142.43 142.43 0 0 0 195.29 94.02 142.43 142.43 0 0 0 52.86 236.45v378h694.43v-90a142.43 142.43 0 0 0-142.43-142.43z",
    fill: primaryColor,
    opacity: 0.1
  }), React.createElement("path", {
    d: "M766.19 597.47s20-31.35 22.36-44.74a172.59 172.59 0 0 1 6.97-25.71",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), React.createElement("path", {
    d: "M800.06 553.8l-12.54 1.07s6.65 11.51 12.54-1.07z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M778.1 546.84l10 8s-12.94 5.12-10-8zM801.67 542.82l-11.33 1.52s9.99 8.12 11.33-1.52zM782.92 538.8l7.48 5.25s-9.08 3.86-7.48-5.25zM793.18 534.02s9.29-2.46 10.63-1.92.54 6.42-3.21 6.69-7.42-4.77-7.42-4.77zM786.94 527.02s5.89 5.62 6.16 7-4.82 4.55-7.5 0 1.34-7 1.34-7z",
    fill: primaryColor
  }), React.createElement("circle", {
    cx: 797.92,
    cy: 527.55,
    r: 2.68,
    fill: "#ffd037"
  }), React.createElement("circle", {
    cx: 793.1,
    cy: 526.21,
    r: 2.68,
    fill: "#ffd037"
  }), React.createElement("path", {
    d: "M654.41 285.12c-10 10.11-10.61 25.61-10.61 25.61s15.49-.88 25.45-11 10.61-25.61 10.61-25.61-15.49.9-25.45 11zM569.52 216.11c3.53 13.75 16.47 22.3 16.47 22.3s7.23-13.73 3.71-27.48-16.48-22.29-16.48-22.29-7.2 13.73-3.7 27.47zM750.37 346.92c-10 10.11-10.62 25.61-10.62 25.61s15.49-.88 25.45-11 10.62-25.61 10.62-25.61-15.49.89-25.45 11zM790.22 433.94c-1.16 14.14 8.27 26.46 8.27 26.46s11.33-10.61 12.49-24.75-8.27-26.46-8.27-26.46-11.33 10.61-12.49 24.75zM1021.15 368.02c-1.16 14.14 8.28 26.46 8.28 26.46s11.32-10.61 12.48-24.75-8.27-26.46-8.27-26.46-11.33 10.63-12.49 24.75z",
    fill: primaryColor,
    opacity: 0.1
  }), React.createElement("path", {
    d: "M64.45 603.89s444.33-84.68 934 0-1177.3 71.69-934 0z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M310.74 617.69c.79 10.12-9.08 17.77-18.52 21.48s-20.21 6-26.72 13.76a12.63 12.63 0 0 0-3.25 7.26c-.3 5.93 5.22 10.43 10.53 13.07 15.2 7.54 32.67 8.46 49.38 11.39s34.31 8.88 43.91 22.87c4.45 6.5 6.87 14.35 11.86 20.5 8 9.77 21.71 13.61 34.21 11.92s23.9-8.22 33.72-16.14c11-8.87 21.14-20 34.83-23.52 23.56-6.11 45.58 12.14 68.09 21.42 27.18 11.2 58.14 9.32 86.69 2.29 6.4-1.58 12.88-3.46 18.33-7.17 6.29-4.27 10.8-10.67 16.69-15.47 14.62-11.92 35.17-12.37 54-12.26l54.69.31c10.81.06 22.33-.08 31.37-6 9.27-6.08 14.17-17.66 13.58-28.73s-6.14-21.51-13.91-29.42c-17.27-17.58-43.33-22.58-67.75-26-117.52-16.23-236.7-14.9-355.36-13.55-19.85.23-39.8.44-59.5 3.19-4.89.68-25.26 1.69-27.18 6.88-1.81 4.88 9.84 15.89 10.31 21.92z",
    fill: primaryColor
  }), React.createElement("ellipse", {
    cx: 172.77,
    cy: 704.93,
    rx: 40.21,
    ry: 6.8,
    fill: primaryColor
  }), React.createElement("ellipse", {
    cx: 204.73,
    cy: 761.35,
    rx: 40.21,
    ry: 6.8,
    fill: primaryColor
  }), React.createElement("ellipse", {
    cx: 79.79,
    cy: 667.18,
    rx: 26.93,
    ry: 4.55,
    fill: primaryColor
  }), React.createElement("ellipse", {
    cx: 299.16,
    cy: 725.47,
    rx: 26.93,
    ry: 4.55,
    fill: primaryColor
  }), React.createElement("ellipse", {
    cx: 876.82,
    cy: 687.68,
    rx: 26.93,
    ry: 4.55,
    fill: primaryColor
  }), React.createElement("ellipse", {
    cx: 706.79,
    cy: 732.09,
    rx: 26.93,
    ry: 4.55,
    fill: primaryColor
  }), React.createElement("ellipse", {
    cx: 991.33,
    cy: 704.93,
    rx: 40.21,
    ry: 6.8,
    fill: primaryColor
  }), React.createElement("ellipse", {
    cx: 829.47,
    cy: 743.07,
    rx: 64.95,
    ry: 10.98,
    fill: primaryColor
  }), React.createElement("ellipse", {
    cx: 522.22,
    cy: 776.69,
    rx: 90.76,
    ry: 15.34,
    fill: primaryColor
  }), React.createElement("path", {
    d: "M998.78 471.25s-20.33 20.33-8.85 50.49-19.68 80.34-19.68 80.34l1-.16c41.75-7.37 62.5-55.13 39.28-90.6-8.67-13.19-15.76-28.66-11.75-40.07z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M998.78 471.25s-11.47 24.92 0 45.25 2 77.38-28.53 85.58",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10
  }), React.createElement("path", {
    d: "M1034.99 553.47s-23.2-3.69-25.31 17.1-44.61 23.67-44.61 23.67l.8.53c35.08 23 68.62 14.67 63.57-15.91-1.92-11.37-1.73-22.79 5.55-25.39z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M1034.99 553.47s-23.2-3.69-25.31 17.1-44.61 23.67-44.61 23.67l.8.53c35.08 23 68.62 14.67 63.57-15.91-1.92-11.37-1.73-22.79 5.55-25.39z",
    fill: "#f5f5f5",
    opacity: 0.2
  }), React.createElement("path", {
    d: "M1034.99 553.47s-18 4-16.53 20.33-26.74 36-53.39 20.44",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10
  }), React.createElement("path", {
    d: "M761.9 573.7s-6.21-21.08 1.16-36.6a33.27 33.27 0 0 0 2.7-20.89 56.7 56.7 0 0 0-3-9.81",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), React.createElement("path", {
    d: "M767.39 496.59c0 2.59-4.68 10.08-4.68 10.08s-4.68-7.49-4.68-10.08a4.68 4.68 0 1 1 9.36 0zM775.12 510.91c-1.4 2.17-9.4 5.91-9.4 5.91s.14-8.83 1.55-11a4.68 4.68 0 1 1 7.85 5.09zM774.78 535.37c-2.3 1.16-11.1.36-11.1.36s4.58-7.56 6.89-8.72a4.68 4.68 0 0 1 4.21 8.36zM770.36 553.81c-2.08 1.54-10.84 2.21-10.84 2.21s3.24-8.22 5.32-9.76a4.68 4.68 0 1 1 5.56 7.52zM755.89 517.32c1.86 1.8 10.49 3.67 10.49 3.67s-2.11-8.58-4-10.38a4.68 4.68 0 0 0-6.52 6.71zM750.99 538.96c2.31 1.17 11.11.36 11.11.36s-4.59-7.55-6.89-8.71a4.68 4.68 0 1 0-4.22 8.35zM749.12 560.65c2.08 1.54 10.88 2.23 10.88 2.23s-3.24-8.21-5.32-9.75a4.68 4.68 0 1 0-5.56 7.52z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M748.39 571.65s11.35-2.27 14.37-5.29 16.65-8.33 18.16-4.54 20.42 16.64 7.56 18.91-30.26 3-34 1.51-6.09-10.59-6.09-10.59z",
    fill: "#a8a8a8"
  }), React.createElement("path", {
    d: "M788.52 579.32c-12.86 2.27-30.26 3-34 1.52-2.88-1.16-4.88-6.69-5.67-9.27l-.38.08s2.27 9.08 6 10.59 21.18.76 34-1.51c3.72-.66 4.78-2.19 4.38-4.14-.33 1.27-1.6 2.25-4.33 2.73z",
    opacity: 0.2
  }), React.createElement("path", {
    d: "M665.42 639.5s34.43-6.89 43.62-16.07 50.5-25.26 55.09-13.78 62 50.51 23 57.39-91.83 9.19-103.31 4.59-18.4-32.13-18.4-32.13z",
    fill: "#a8a8a8"
  }), React.createElement("path", {
    d: "M787.09 662.78c-39 6.89-91.83 9.18-103.31 4.59-8.74-3.5-14.81-20.3-17.21-28.11l-1.15.24s6.89 27.54 18.36 32.13 64.28 2.3 103.31-4.59c11.26-2 14.48-6.65 13.27-12.56-.96 3.85-4.84 6.82-13.27 8.3z",
    opacity: 0.2
  }), React.createElement("path", {
    d: "M90.46 505.45c15.33 22.63 10.44 103.64 10.44 103.64s-77-25.5-92.38-48.13a49.49 49.49 0 1 1 81.94-55.51z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M90.46 505.45c15.33 22.63 10.44 103.64 10.44 103.64s-77-25.5-92.38-48.13a49.49 49.49 0 1 1 81.94-55.51z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M22.03 492.29s57.74 44.57 79.17 116.86",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10
  }), React.createElement("path", {
    d: "M115.74 547.75s-41-7-12.95 60.91c0 0 28.49-10.86 30.71-37.88a21.56 21.56 0 0 0-17.15-22.92z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M116.34 547.67s7.82 37.56-13.55 61",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10
  }), React.createElement("path", {
    d: "M966.31 546.32s5.49 7.19-2.54 18-14.65 20-12 26.77c0 0 12.11-20.15 22-20.43s3.38-12.22-7.46-24.34z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M966.31 546.32a9.25 9.25 0 0 1 1.12 2.26c9.62 11.3 14.74 21.85 5.5 22.11-8.62.25-19 15.65-21.43 19.54a9.3 9.3 0 0 0 .3.89s12.11-20.15 22-20.43 3.35-12.25-7.49-24.37z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M976.52 555.48c0 2.53-.29 4.58-.64 4.58s-.63-2-.63-4.58.36-1.34.71-1.34.56-1.19.56 1.34z",
    fill: "#ffd037"
  }), React.createElement("path", {
    d: "M980.02 558.5c-2.22 1.21-4.15 1.94-4.32 1.63s1.5-1.53 3.72-2.74 1.34-.33 1.51 0 1.31-.1-.91 1.11z",
    fill: "#ffd037"
  }), React.createElement("path", {
    d: "M937.29 546.32s-5.49 7.19 2.53 18 14.65 20 12 26.77c0 0-12.12-20.15-22-20.43s-3.38-12.22 7.47-24.34z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M937.29 546.32a8.83 8.83 0 0 0-1.12 2.26c-9.62 11.3-14.75 21.85-5.5 22.11 8.61.25 19 15.65 21.42 19.54a9.24 9.24 0 0 1-.29.89s-12.12-20.15-22-20.43-3.36-12.25 7.49-24.37z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M927.08 555.48c0 2.53.28 4.58.63 4.58s.63-2 .63-4.58-.35-1.34-.7-1.34-.56-1.19-.56 1.34z",
    fill: "#ffd037"
  }), React.createElement("path", {
    d: "M923.57 558.5c2.22 1.21 4.16 1.94 4.33 1.63s-1.5-1.53-3.72-2.74-1.35-.33-1.51 0-1.32-.1.9 1.11z",
    fill: "#ffd037"
  }), React.createElement("path", {
    d: "M928.83 590.18s15.36-.48 20-3.77 23.63-7.23 24.78-1.95 23.08 26.29 5.74 26.43-40.29-2.7-44.91-5.51-5.61-15.2-5.61-15.2z",
    fill: "#a8a8a8"
  }), React.createElement("path", {
    d: "M979.64 609.02c-17.34.14-40.29-2.7-44.91-5.51-3.52-2.14-4.92-9.83-5.39-13.38h-.51s1 12.38 5.59 15.2 27.57 5.65 44.91 5.51c5 0 6.74-1.82 6.64-4.45-.7 1.63-2.6 2.63-6.33 2.63z",
    opacity: 0.2
  }), React.createElement("path", {
    d: "M1007.95 693.82a11.64 11.64 0 0 0 3.83-5.79c.5-2.3-.48-5-2.68-5.89-2.46-.94-5.08.76-7.08 2.49s-4.27 3.68-6.88 3.32a10.5 10.5 0 0 0 3.24-9.81 4.11 4.11 0 0 0-.9-2c-1.37-1.45-3.84-.83-5.48.32-5.2 3.66-6.65 10.72-6.68 17.08-.52-2.29-.08-4.68-.09-7s-.66-5-2.65-6.23a8 8 0 0 0-4-1c-2.34-.08-5 .15-6.54 1.86-2 2.13-1.47 5.69.25 8s4.35 3.8 6.77 5.42a15.13 15.13 0 0 1 4.84 4.61 5.06 5.06 0 0 1 .35.82h14.66a40.73 40.73 0 0 0 9.04-6.2zM315.78 714.59a11.73 11.73 0 0 0 3.84-5.79c.49-2.29-.49-5-2.68-5.89-2.46-.94-5.09.77-7.08 2.49s-4.28 3.69-6.89 3.32a10.47 10.47 0 0 0 3.24-9.81 4.12 4.12 0 0 0-.9-2c-1.37-1.46-3.84-.84-5.48.31-5.2 3.66-6.65 10.73-6.67 17.08-.53-2.29-.09-4.68-.1-7s-.66-5-2.64-6.23a8 8 0 0 0-4-.94c-2.34-.09-4.94.15-6.54 1.86-2 2.12-1.47 5.68.26 8s4.35 3.81 6.76 5.42a15 15 0 0 1 4.84 4.61 4.83 4.83 0 0 1 .36.83h14.62a40.77 40.77 0 0 0 9.06-6.26z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M216.78 621.47s-14.06-47.71 2.63-82.83a75.4 75.4 0 0 0 6.1-47.27 127.26 127.26 0 0 0-6.7-22.19",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), React.createElement("path", {
    d: "M229.2 447.02c0 5.84-10.59 22.8-10.59 22.8s-10.59-17-10.59-22.8a10.59 10.59 0 0 1 21.18 0zM246.7 479.38c-3.18 4.9-21.28 13.38-21.28 13.38s.32-20 3.5-24.89a10.59 10.59 0 1 1 17.78 11.51zM245.93 534.72c-5.22 2.63-25.13.81-25.13.81s10.38-17.08 15.6-19.72a10.59 10.59 0 1 1 9.53 18.91zM235.92 576.47c-4.7 3.47-24.63 5-24.63 5s7.34-18.59 12-22.07a10.59 10.59 0 1 1 12.59 17zM203.19 493.89c4.19 4.08 23.73 8.3 23.73 8.3s-4.79-19.41-9-23.48a10.583 10.583 0 1 0-14.75 15.18zM192.1 542.86c5.22 2.64 25.13.82 25.13.82s-10.38-17.09-15.6-19.72a10.583 10.583 0 1 0-9.53 18.9zM187.86 591.94c4.66 3.48 24.66 5.08 24.66 5.08s-7.34-18.6-12-22.07a10.59 10.59 0 1 0-12.59 17z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M229.2 447.02c0 5.84-10.59 22.8-10.59 22.8s-10.59-17-10.59-22.8a10.59 10.59 0 0 1 21.18 0zM246.7 479.38c-3.18 4.9-21.28 13.38-21.28 13.38s.32-20 3.5-24.89a10.59 10.59 0 1 1 17.78 11.51zM245.93 534.72c-5.22 2.63-25.13.81-25.13.81s10.38-17.08 15.6-19.72a10.59 10.59 0 1 1 9.53 18.91zM235.92 576.47c-4.7 3.47-24.63 5-24.63 5s7.34-18.59 12-22.07a10.59 10.59 0 1 1 12.59 17zM203.19 493.89c4.19 4.08 23.73 8.3 23.73 8.3s-4.79-19.41-9-23.48a10.583 10.583 0 1 0-14.75 15.18zM192.1 542.86c5.22 2.64 25.13.82 25.13.82s-10.38-17.09-15.6-19.72a10.583 10.583 0 1 0-9.53 18.9zM187.86 591.94c4.66 3.48 24.66 5.08 24.66 5.08s-7.34-18.6-12-22.07a10.59 10.59 0 1 0-12.59 17z",
    fill: "#fc6681"
  }), React.createElement("path", {
    d: "M183.57 618.46s17.11-3.4 21.67-7.93 25.1-12.46 27.38-6.79 30.8 24.91 11.41 28.31-45.63 4.53-51.34 2.27-9.12-15.86-9.12-15.86z",
    fill: "#a8a8a8"
  }), React.createElement("path", {
    d: "M244.03 629.95c-19.4 3.39-45.63 4.53-51.34 2.26-4.34-1.72-7.36-10-8.55-13.87l-.57.12s3.42 13.59 9.12 15.86 31.94 1.13 51.34-2.27c5.59-1 7.19-3.28 6.59-6.2-.48 1.9-2.43 3.37-6.59 4.1z",
    opacity: 0.2
  }), React.createElement("path", {
    d: "M1075.68 75.02v193.77c0 32.12-39.65 47.57-61.17 23.72l-.51-.56c-6.94-7.77-16.44-17.22-26-13.08-3 1.27-5.22 3.69-7.86 5.53a114.57 114.57 0 0 1 4.93 13c8.25 27.32 1.82 56.84-7 84s-20.08 54.06-21.59 82.57c-.72 13.69.85 27.39 2.41 41 3 25.86 6.07 52.22 16.88 75.9 5.92 13 14.29 26.06 12.52 40.19a408.78 408.78 0 0 1-137.77-17.5c30.86-31.07 30.82-80.37 28.76-124.11q-2.47-52.84-5-105.7c-.48-10.32-1.06-21-5.77-30.2-6.39-12.53-19.71-20.39-33.43-23.53s-28-2.29-42.07-1.4a22.53 22.53 0 0 1 2.93-15.95 200.58 200.58 0 0 0 69.29 16.25c3 .15 6.37.12 8.6-1.91s2.57-5.38 2.71-8.4a183.89 183.89 0 0 0-4.72-52.06c-.77.19-1.54.38-2.31.62-11.76 3.56-22.41 12.35-34.66 11.42-17.12-1.3-27.27-20.48-43.4-26.37-12.36-4.52-25.95-.53-38.9 1.82s-28.3 2.19-36.81-7.85c-10.74-12.68-4-32.79-11-47.89-9.89-21.5-39.83-21.9-63.33-19a74.5 74.5 0 0 1 39.69-29.86c-8.32-14.93-37.56-14.26-37.39-31.35.06-6.63 5.34-11.9 10.24-16.37l22-20.06-38.93-14.7c-8.72-3.29-18.46-7.61-21.37-16.46-2.84-8.68 2.32-18 8.74-24.51l.17-.16A54.56 54.56 0 0 1 663.26.02h337.43a75 75 0 0 1 74.99 75z",
    fill: primaryColor,
    opacity: 0.1
  }), React.createElement("path", {
    d: "M366.76 722.28s22.91 6.29 33.95-2.07 15.82-5.67 15.82-5.67 26.31-1.46 28.47-7.67-10.09-28.81-10.09-28.82c-.88-1.95-2.14-4.55-2.72-4.55l.12-9.53 3.81-39.86c8.8-22.55.16-51.7.16-51.7l-1.57-7.23a18.14 18.14 0 0 1 1.49-12l16-32.15a47.75 47.75 0 0 1 3-6.15c1-1.84 2.33-4.11 4-6.83.49-.77 1-1.59 1.56-2.44 1.94-3 4.29-6.42 7.12-10.35 7.08-9.8 10.8-22 12.72-31.1l.85 2.83h.37l.32.06h.06l.41.06h.16l4.91 62.54c.31 24.39 9.26 37.89 9.26 37.89l-1.24 53.84c1.69 13-2 30.27-3.69 37.16l-3.88 8.74a10.52 10.52 0 0 0-5.7 7.94c-.77 6.45-7.56 20.35-7.56 20.35-2.48 3.43-8.19 12.43-8.19 12.43s-2.78 8.59-1.08 11.81 15.58 2.92 15.58 2.92c15.9 3.52 28.09-5.07 27.32-10.9s2.46-7.36 2.46-7.36c6.33-2 5.71-6.29 5.71-6.29a39.35 39.35 0 0 0-4.78-25.62l-1 2.32a35 35 0 0 1 1.91-13.67c-.2.14-.39.28-.59.4l-.18.12h-.06c1-8.79 10.24-25.09 10.24-25.09 17-29.76 10.8-70.11 10.8-70.11l-2.6-12.53-.15-4.74a158 158 0 0 1 2.51-33.78c.91-4.93 1.85-10.89 2.58-17.47 1.52-13.88 6.44-28.2 8.7-34.26l.68-.12h.09l2.8-.49h.18s.54-2.93 1-7.92c.27-3.18.49-7.21.49-11.84a133.05 133.05 0 0 0-6.32-41.23l.5-.74s1.22-1.64 3.43-4.49c4.08-5.17 10.41-13 18.23-21.91 14-15.95 9.87-32.11 9.87-32.11s-10.08-37-14.61-59.32c-2.57-12.68-7.41-21.32-11.11-26.42a52 52 0 0 0 1.4-10.71c.31-6.6.07-13.48-2.89-19.4s-9.29-10.62-15.89-9.82a6.1 6.1 0 0 1-2.85 0 4.29 4.29 0 0 1-1.87-1.64c-3.87-5.32-4.12-12.48-2.92-18.94s3.68-12.64 4.78-19.12.61-13.67-3.52-18.8c-4.84-6-13.29-7.72-19.59-12.24-4.42-3.18-7.74-7.75-12.4-10.56s-9-1.75-14.09-.68c-8.52 1.79-16.61 2.61-24.66 6.28a65.63 65.63 0 0 0-21.5 15.63 20.52 20.52 0 0 0-4.79 7.57c-2 6.62 1.91 13.68 1.09 20.54-.58 4.86-3.45 9.1-5.73 13.44s-4 9.5-2.22 14.06c2.8 7.09 12 8.6 18.62 12.38a5.63 5.63 0 0 1 2.21 1.91c1.64 2.87-1.72 5.85-3.83 8.4a12.66 12.66 0 0 0-2.51 5.09 18.21 18.21 0 0 0-10.9 13.16c-2.26 10.1 1.21 22.85 4.27 31.27-3.34 18.77 1 26.17 4.2 29a16 16 0 0 1 5.58 11v.35c.21 3.42.57 6.81 1.05 10.2-.11-.79-.22-1.63-.28-2-2.62 4.85-7.6 17.22-10.41 38a114.27 114.27 0 0 1-2.54 13.25 72.69 72.69 0 0 0-2.13 23.69l.51 6.75a2 2 0 0 1-1.36-.45l3.52 6.45V432a40.16 40.16 0 0 1-2.67 14.34c-.25.67-.53 1.33-.82 2a11.67 11.67 0 0 0-1.18 5.9c-7.59 11.57-24.96 76.6-24.96 76.6-9.42 21.32.77 35.13.77 35.13s4.94 59.37 5.86 62.43 2.93 39.27 2.93 39.27v2.88a7.2 7.2 0 0 0-1.71-.5c-8.26-.46-10.5 12.58-10.5 12.58l-16.89 16.18s-7.72-1.3-19.06 7.21 7.36 16.26 7.36 16.26zM535.4 379.2v-.18l-.46.27-.19.11h-.09L526.8 352a45.53 45.53 0 0 1-.58-22.6l6-26.36v-6.34l19.13 51c1.27 6.83-10.09 23.48-15.95 31.5z",
    transform: "translate(-55.48 -53.98)",
    fill: "url(#prefix__a)"
  }), React.createElement("path", {
    d: "M488.29 408.12s-7.73 18.78-9.7 36.81c-.71 6.49-1.63 12.38-2.53 17.25a156.72 156.72 0 0 0-2.46 33.36l.14 4.69 2.58 12.42s6.06 39.84-10.6 69.23c0 0-9.85 17.57-10.15 25.91l-6.67 2.57-13.48-3.79s6.51-23.33 4.39-39.69l1.21-53.17s-8.78-13.33-9.09-37.42l-5.15-66zM426.78 398.73s-1.66 25.75-14.39 43.47-15.44 25.45-15.44 25.45l-15.69 31.75a18.13 18.13 0 0 0-1.47 11.86l1.54 7.14s8.49 28.79-.15 51.06l-4.09 43h-23.93s-2-35.75-2.88-38.78-5.76-61.66-5.76-61.66-10-13.63-.76-34.69c0 0 20.91-78.78 26.51-77.41s56.51-1.19 56.51-1.19z",
    fill: "#fdc2cc"
  }), React.createElement("path", {
    d: "M378.91 518.4l-1.54-7.14a18.07 18.07 0 0 1 1.47-11.86l15.68-31.75s2.72-7.72 15.45-25.45c12.23-17 14.24-41.48 14.38-43.36l2.43-.11s-1.66 25.75-14.39 43.47-15.44 25.45-15.44 25.45l-15.69 31.75a18.13 18.13 0 0 0-1.47 11.86l1.54 7.14s8.49 28.79-.15 51.06l-4.09 43h-2.42l4.09-43c8.63-22.27.15-51.06.15-51.06zM453.14 607.79c.3-8.34 10.15-25.91 10.15-25.91 16.67-29.39 10.61-69.23 10.61-69.23l-2.58-12.42-.15-4.69a157.38 157.38 0 0 1 2.47-33.36c.89-4.87 1.82-10.76 2.53-17.25 1.89-17.36 9.12-35.41 9.66-36.73l2.46-.08s-7.73 18.78-9.7 36.81c-.71 6.49-1.63 12.38-2.53 17.25a156.72 156.72 0 0 0-2.46 33.36l.14 4.69 2.58 12.42s6.06 39.84-10.6 69.23c0 0-9.85 17.57-10.15 25.91l-6.67 2.57-1.38-.34z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M445.42 607.48a11.58 11.58 0 0 0 11.1-1.36 35.59 35.59 0 0 0-.9 20c2.72 10.9-25.46-8.79-25.46-8.79l6.07-13.75s2.22 4.36 9.19 3.9z",
    fill: "#d39999"
  }), React.createElement("path", {
    d: "M447.52 608.09a11.24 11.24 0 0 0 8.95-2 35.59 35.59 0 0 0-.9 20c2.72 10.9-25.46-8.79-25.46-8.79l6.07-13.75s1.75 3.35 6.88 3.87c1.46.18 2.98.39 4.46.67z",
    opacity: 0.1
  }), React.createElement("path", {
    fill: "#fdc2cc",
    d: "M381.49 352.61h11.77v-66.8l-8.83-1.59-2.94 68.39z"
  }), React.createElement("path", {
    opacity: 0.05,
    d: "M381.49 352.61h11.77v-66.8l-8.83-1.59-2.94 68.39z"
  }), React.createElement("path", {
    d: "M438.75 612.63s7.42-.45 10.76 6.21l4.09 3.19 2-4.7a39.05 39.05 0 0 1 4.69 25.3s.61 4.24-5.6 6.21c0 0-3.18 1.52-2.43 7.27s-11.21 14.24-26.81 10.76c0 0-13.64.3-15.3-2.88s1.06-11.67 1.06-11.67 5.6-8.88 8.18-12.17c0 0 6.66-13.73 7.42-20.09s8-10.91 11.94-7.43z",
    fill: "#7e5659"
  }), React.createElement("path", {
    d: "M377.32 618.24l.12-9.41s-13.55 3.88-24.52-.51c0 0 .92 9.46-.6 10.75s5.08 13.48 5.08 13.48l7.37 7.73 12.67-4.62 3.44-10.83s-2.65-6.59-3.56-6.59z",
    fill: "#d39999"
  }), React.createElement("path", {
    d: "M377.32 618.24l.12-9.41s-13.55 3.88-24.52-.51c0 0 .92 9.46-.6 10.75s5.08 13.48 5.08 13.48l7.37 7.73 12.67-4.62 3.44-10.83s-2.65-6.59-3.56-6.59z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M351.52 614.83s7.2.83 6.29 10 .38 0 .38 0 7.65 3.1 10.37 7.42 7.65-3.86 8-6.21 3.43-3.31 3.43-3.31 12 22.32 9.9 28.46-27.95 7.57-27.95 7.57-4.69-2.65-15.53 5.61-33.32 2-33.32 2-18.33-7.65-7.2-16 18.71-7.13 18.71-7.13l16.59-16s2.19-12.86 10.33-12.41z",
    fill: "#7e5659"
  }), React.createElement("path", {
    d: "M437.52 87.29c4.58 2.77 7.84 7.29 12.18 10.42 6.18 4.47 14.47 6.13 19.23 12.09 4 5.07 4.53 12.17 3.45 18.57s-3.51 12.5-4.69 18.88-.93 13.45 2.87 18.7a4.15 4.15 0 0 0 1.83 1.62 6 6 0 0 0 2.8 0c6.48-.78 12.69 3.85 15.6 9.7s3.14 12.64 2.84 19.16c-.25 5.35-.85 10.81-3.2 15.62-4 8.18-12.35 13.24-20.59 17.11a159.08 159.08 0 0 1-16.44 6.64c-3.84 1.31-7.91 2.48-11.91 1.79-6.85-1.18-11.7-7.4-18.2-9.85-5.33-2-11.24-1.28-16.91-.78-4.83.42-10.36.42-13.68-3.11-4.27-4.54-2.35-11.85-.17-17.68a12.6 12.6 0 0 1-8.9-20.58c2.07-2.52 5.36-5.46 3.75-8.3a5.58 5.58 0 0 0-2.16-1.89c-6.54-3.73-15.53-5.22-18.28-12.22-1.77-4.51-.05-9.6 2.18-13.89s5.05-8.47 5.62-13.27c.81-6.78-3-13.75-1.07-20.29a20.34 20.34 0 0 1 4.7-7.47 64.68 64.68 0 0 1 21.11-15.44c7.91-3.62 15.85-4.43 24.21-6.2 4.94-1.06 9.09-2.19 13.83.67z",
    fill: "#865a61"
  }), React.createElement("path", {
    d: "M393.25 188.25s-19.19-1-22.82 15.35 7.87 39.79 7.87 39.79z",
    fill: "#fdc2cc"
  }), React.createElement("path", {
    d: "M393.25 188.25s-19.19-1-22.82 15.35 7.87 39.79 7.87 39.79z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M381.03 236.93l7.27 5.76 33.94 1.51 21.17-14.54 21.55-37c-13.18-3.36-18.5-12.45-20.48-21a45.92 45.92 0 0 1-.43-17.51s-34.54-17.88-30.3 10a37.23 37.23 0 0 1 .32 10.37c-2 16.34-17.87 13.27-17.87 13.27l-6.08 9.39-7 23z",
    fill: "#fdc2cc"
  }), React.createElement("path", {
    d: "M413.75 164.21a37.23 37.23 0 0 1 .32 10.37 30.63 30.63 0 0 0 30.45-2.85 45.92 45.92 0 0 1-.43-17.51s-34.57-17.88-30.34 9.99z",
    opacity: 0.1
  }), React.createElement("circle", {
    cx: 426.81,
    cy: 145.53,
    r: 30.6,
    fill: "#fdc2cc"
  }), React.createElement("path", {
    d: "M405.17 231.09c.73.05 1.47.12 2.2.19 4 .4 20.77 1.3 30.32-10.1 10.68-12.76 24.9-28.52 25.48-29.16l14.47 4.38s-11.45-4.08-19.08 17.22a22.11 22.11 0 0 0 7.5 25.4 23 23 0 0 0 9.46 4 .05.05 0 0 1 0 .05v9.35l-5.92 26a45.23 45.23 0 0 0 .56 22.32l9 31.9v.05c-1.36.94-57.37 39-94.78 12.73.14-1.14 4.76-38.58 1.56-56.9a126.89 126.89 0 0 1-1.68-14.16v-.35a16 16 0 0 0-5.48-10.83c-3.37-3-7.94-11-3.43-32.24a78.09 78.09 0 0 1 5-15.27l12.54-28.35a.05.05 0 0 1 .05 0l11.56.23v.07c-1 1.25-14.41 18-15.86 28.79-1.43 10.27-3.18 13.42 16.53 14.68z",
    fill: "#d39999"
  }), React.createElement("path", {
    d: "M487.38 201.38s11.31 9.7 15.75 31.71 14.39 58.58 14.39 58.58 4 16-9.7 31.71S485 351.46 485 351.46l-9 13.29a11.29 11.29 0 0 1-6.5 4.59c-4.12 1.09-10.43 1.87-15.91-1.13a9.27 9.27 0 0 1-4.05-11.7l1.95-4.65s-18.58 11.72-20.19 5.25 21.61-12.92 21.61-12.92 19.19-3.23 23-12.32c0 0 20.6-26.46 19-35.55l-19.95-53.3s-24.76-3.28-16.27-31.23 28.69-10.41 28.69-10.41z",
    fill: "#fdc2cc"
  }), React.createElement("path", {
    d: "M368.41 402.56s45.45 9.09 56.15 7.88l1.15 3.84s17.26 3.86 56.25-2.33q3.82-.6 7.94-1.35l.91-.16s.54-2.89 1-7.82c.94-11.18 1.27-32.83-6.6-55l-6.57-20.2s-40.53 24.3-67.37 22.06c-2.39-.2-4.78-.39-7.17-.48-5.51-.2-14 0-19.58-4.44l-11.64 2v33.16a39.81 39.81 0 0 1-2.63 14.16c-.25.66-.51 1.31-.8 2-.99 2.14-1.62 4.54-1.04 6.68z",
    fill: "#7e5659"
  }), React.createElement("path", {
    d: "M425.71 404.02v10.3s19.86 4.44 65.1-3.84c0 0 .54-2.89 1-7.82-13.93 2.19-52.21 7.55-66.1 1.36z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M368.41 402.56s45.45 9.09 56.15 7.88l1.15 3.84v-10.26c-5.17 2.14-42.13-6.76-55.51-10.1-.25.66-.51 1.31-.8 2-.94 2.1-1.57 4.5-.99 6.64z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M478.59 391.02l3.37 20.9q3.82-.6 7.94-1.35c-1-6.11-3.35-20-2.72-22.38l-4.24-3.63z",
    fill: "#7e5659"
  }), React.createElement("path", {
    d: "M478.59 391.02l3.37 20.9q3.82-.6 7.94-1.35c-1-6.11-3.35-20-2.72-22.38l-4.24-3.63z",
    opacity: 0.1
  }), React.createElement("g", {
    opacity: 0.05
  }, React.createElement("path", {
    d: "M408.79 349.48c-2.39-.2-4.77-.39-7.17-.48-5.35-.19-13.53 0-19.1-4.1l1.95-.34c5.57 4.43 14.07 4.24 19.58 4.44 2.39.09 4.78.28 7.17.48.78.07 1.58.11 2.39.13a45.13 45.13 0 0 1-4.82-.13zM479.52 411.95q3.83-.6 7.94-1.35l.91-.16s.53-2.89 1-7.82c.94-11.18 1.27-32.83-6.61-55l-6.18-19c1.32-.74 2-1.18 2-1.18l6.57 20.2c7.87 22.17 7.54 43.82 6.6 55-.41 4.93-1 7.82-1 7.82l-.91.16q-4.11.75-7.94 1.35c-18.21 2.89-31.68 3.59-40.87 3.51a256.12 256.12 0 0 0 38.49-3.53zM422.13 410.44v.11h-1.31c.51-.04.93-.07 1.31-.11z"
  })), React.createElement("ellipse", {
    cx: 484.25,
    cy: 391.45,
    rx: 1.71,
    ry: 3.53,
    fill: "#d39999"
  }), React.createElement("path", {
    d: "M374.79 319.96c2.76-20.56 7.65-32.78 10.22-37.56.11.66.37 2.77.48 3.43.53 3 .07 6.79.23 10.61l-2.57 46.58 3.44 14.54c3.23 11.51-8.74 2.42-8.74 2.42-2.48 5.46-7 4.85-7 4.85l-.62-8.34a72 72 0 0 1 2.09-23.4 113.57 113.57 0 0 0 2.47-13.13z",
    fill: "#fdc2cc"
  }), React.createElement("path", {
    d: "M374.79 319.96c2.76-20.56 7.65-32.78 10.22-37.56.11.66.37 2.77.48 3.43.53 3 .07 6.79.23 10.61l-2.57 46.58 3.44 14.54c3.23 11.51-8.74 2.42-8.74 2.42-2.48 5.46-7 4.85-7 4.85l-.62-8.34a72 72 0 0 1 2.09-23.4 113.57 113.57 0 0 0 2.47-13.13z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M489.9 345.02c-2.18 2.81-3.37 4.43-3.37 4.43l-9 13.29a11.27 11.27 0 0 1-6.49 4.59c-4.12 1.09-10.44 1.87-15.91-1.13a9.25 9.25 0 0 1-4.05-11.7l2-4.65s-18.58 11.72-20.2 5.26 21.61-12.93 21.61-12.93 19.19-3.23 23-12.32c0 0 1.68-2.16 4-5.45",
    fill: "#fdc2cc"
  }), React.createElement("path", {
    d: "M478.59 367.32s-22-2.13-28.93-14.7l-3.14 10.34s23 15.92 28.33 13.86z",
    fill: "#7e5659"
  }), React.createElement("path", {
    d: "M478.59 367.32s-22-2.13-28.93-14.7l-3.14 10.34s23 15.92 28.33 13.86z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M378.57 361.46s-7.69 2.72-9.2 1.21l3.46 6.36 6.53-5z",
    fill: "#7e5659"
  }), React.createElement("path", {
    d: "M378.57 361.46s-7.69 2.72-9.2 1.21l3.46 6.36 6.53-5zM425.71 403.98v-13.29l-3.16 13.61 3.16-.32zM456.87 129.38c-1.85 2.6-5.07 3.93-8.24 4.34s-6.38.06-9.58 0c-5-.09-10.34.68-14.45 3.63-2.62 1.88-4.58 4.51-6.63 7-6.2 7.58-14.81 14.66-24.57 13.87a6.34 6.34 0 0 1-4.56-1.93 7.23 7.23 0 0 1-1.17-4.14 95.24 95.24 0 0 1 .59-18.72 39.23 39.23 0 0 1 2.84-11.16 37.74 37.74 0 0 1 6.79-9.71 41.6 41.6 0 0 1 11.87-9.51c4.57-2.27 9.92-3.25 14.84-1.91 5.84 1.59 10.4 6.16 16 8.52 6.35 2.71 23.26 9.86 16.27 19.72z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M456.87 128.16c-1.85 2.61-5.07 3.93-8.24 4.35s-6.38.06-9.58 0c-5-.08-10.34.69-14.45 3.63-2.62 1.89-4.58 4.52-6.63 7-6.2 7.57-14.81 14.66-24.57 13.87a6.34 6.34 0 0 1-4.56-1.93 7.24 7.24 0 0 1-1.17-4.15 95.17 95.17 0 0 1 .59-18.71 39.23 39.23 0 0 1 2.84-11.16 37.74 37.74 0 0 1 6.79-9.71 41.6 41.6 0 0 1 11.87-9.51c4.57-2.27 9.92-3.25 14.84-1.91 5.84 1.59 10.4 6.16 16 8.52 6.35 2.7 23.26 9.86 16.27 19.71z",
    fill: "#865a61"
  }), React.createElement("path", {
    fill: "#fdc2cc",
    d: "M384.47 344.56l-.08 3.66-.82-3.5.9-.16z"
  }), React.createElement("path", {
    opacity: 0.05,
    d: "M384.47 344.56l-.08 3.66-.82-3.5.9-.16zM461.81 209.84c-8.49 27.95 16.27 31.23 16.27 31.23l19.9 53.33c1.61 9.09-19 35.55-19 35.55-1.43 3.4-5 6-8.93 7.87a13.89 13.89 0 0 0 5.3-5.81s20.6-26.46 19-35.55l-19.89-53.33s-24.76-3.28-16.27-31.23c2.84-9.34 7-13.59 11.25-15.12-2.92 2.35-5.61 6.41-7.63 13.06z"
  }), React.createElement("g", {
    opacity: 0.1
  }, React.createElement("path", {
    d: "M462.22 235.24a21 21 0 0 0 4 3.8 22.89 22.89 0 0 0 9.46 4v1a22.83 22.83 0 0 1-8.59-3.81 21 21 0 0 1-4.87-4.99zM385.3 275.22v.35a124.85 124.85 0 0 0 1.68 14.16c3 17.29-.93 51.62-1.5 56.37-.32-.21-.64-.42-1-.64.14-1.14 4.76-38.58 1.56-56.9a127.17 127.17 0 0 1-1.68-14.16v-.35a15.47 15.47 0 0 0-2.69-7.67 15.69 15.69 0 0 1 3.63 8.84zM403.76 188.69l-9.81-.19a.05.05 0 0 0-.05 0l-12.54 28.35a77.87 77.87 0 0 0-5 15.27c-3.65 17.15-1.36 25.69 1.43 29.91-3.14-3.7-6.38-12.14-2.34-31.12a78.18 78.18 0 0 1 5-15.28l12.54-28.34 11.56.22v.08c-.03.15-.35.53-.79 1.1zM477.67 196.38h.17z"
  }), React.createElement("path", {
    d: "M474.07 196.23l-9.79-3c-.58.65-14.8 16.4-25.48 29.16-9.55 11.4-26.29 10.51-30.32 10.11-.73-.08-1.47-.14-2.2-.19-11-.7-15.28-2-16.72-4.77 2.06 2 6.58 3 15.81 3.56.73.05 1.47.11 2.2.18 4 .41 20.77 1.3 30.32-10.1 10.68-12.76 24.9-28.51 25.48-29.16l14.3 4.33a8.83 8.83 0 0 0-3.6-.12z"
  })), React.createElement("path", {
    d: "M357.7 629.41s-13.84 3.78-16.51-2.16M445.57 626.57s-16.09 4.14-19.76-2.27",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M705.2 609.9s-2-8-3.77-15.89c-.37-4.94-1.24-11.35-1.61-14v-.32a4.25 4.25 0 0 0-1.13-2.9c1-2.88 4.63-13.84 3.95-17-.78-3.64-3.58-12.52-6.9-15.45a8.89 8.89 0 0 0-4.37-3.45 11.52 11.52 0 0 0-9.72.78l-16.88 9.47c-6.77-1-12.26-1.77-12.26-1.77s-4.19-.5-9.43-1c-1.63-3.88-7-15.61-12.57-17.47-6-2-13 .71-14.53 1.34h-.08l-.2.08c-11 5.09-9.72 26.64-9.3 31.35a78.17 78.17 0 0 1-6.62 7.37c-3.77 3.32-4.94 12-1.43 13.79 1.66.85 4 1.86 6.08 2.69-9.52 20.25-25.63 60.06-11.2 71.37 19.62 15.37 56.38 20.48 69 15.37a2 2 0 0 0 1-.07s20.45-4.87 25.23-10.32a35.37 35.37 0 0 0 7.15-15.4 29.92 29.92 0 0 0 9.6-16.79c2.51-12.58-.01-21.78-.01-21.78zm-12.79-43.66l.49-2.42.81.45c-.13.67-.27 1.36-.45 2.07l-.76 4.66zm-3.85-20.14c.87.58 6.64 4.87 5.49 15.82a5.28 5.28 0 0 0-.32-1.24c-.25-1.57-1.38-3.7-5.28-5a85.26 85.26 0 0 0-10.2-2.27 33.79 33.79 0 0 1 10.31-7.31zm-57.35 1.14c-4.42-.34-7.9-.48-8.38-.14h-.07a4 4 0 0 0-1.68.21 12.84 12.84 0 0 0-4.75 2.22c2-11.19 7.84-12.13 9.11-12.2a31 31 0 0 1 5.77 9.91zM694.75 636c-.61-9.14-1.17-23.42-1.47-31.74l.51-.08a13.28 13.28 0 0 0 1.7-.34c.56 5.38 1.56 11.77 3.29 15.92 2.22 5.36-1.25 12.1-4.03 16.24z",
    transform: "translate(-55.48 -53.98)",
    fill: "url(#prefix__b)"
  }), React.createElement("path", {
    fill: "#cd939c",
    d: "M635.52 507.28l-11.4-3.54-12.29 4.43-.88 7.72 6.07 3.93 9.63-.32 8.49-3.99 1.45-7.34-1.07-.89z"
  }), React.createElement("path", {
    opacity: 0.2,
    d: "M635.52 507.28l-11.4-3.54-12.29 4.43-.88 7.72 6.07 3.93 9.63-.32 8.49-3.99 1.45-7.34-1.07-.89z"
  }), React.createElement("path", {
    d: "M552.11 511.08s-3.11-26.7 9.22-32.1c0 0 6.59.33 9.46 5.06 0 0-9-.5-9.73 18.24z",
    fill: "#f6c6cd"
  }), React.createElement("path", {
    d: "M552.11 511.08s-3.11-26.7 9.22-32.1c0 0 6.59.33 9.46 5.06 0 0-9-.5-9.73 18.24z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M558.76 501.52s-9.5 12.67-13.18 16-4.81 11.91-1.39 13.68 10 4.31 10 4.31z",
    fill: "#cd939c"
  }), React.createElement("path", {
    d: "M558.76 501.52s-9.5 12.67-13.18 16-4.81 11.91-1.39 13.68 10 4.31 10 4.31z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M588.2 496.2s-6.2-16.34-12.72-18.55-14.42 1.45-14.42 1.45 9.6-1 15.49 15.83zM641.57 523.88s4.83-13.94 4.07-17.55-3.48-12.41-6.71-15.32-7.09 1.64-7.09 1.64 8.3 5 4.69 20.14l-1.08 6.72z",
    fill: "#f6c6cd"
  }), React.createElement("path", {
    d: "M641.57 523.88s4.83-13.94 4.07-17.55-3.48-12.41-6.71-15.32-7.09 1.64-7.09 1.64 8.3 5 4.69 20.14l-1.08 6.72z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M606.32 499.18l18.9-10.81a11 11 0 0 1 9.46-.77 8.63 8.63 0 0 1 4.25 3.41s-9.12-.51-19.25 11.4zM638 540.28s.51 17.22 3.89 25.5-6.76 19.93-6.76 19.93l1.86 10s8.7-5.57 11.15-18.07 0-21.61 0-21.61-7-28.08-6-31.08-4.14 15.33-4.14 15.33z",
    fill: "#f6c6cd"
  }), React.createElement("path", {
    d: "M638 540.28s.51 17.22 3.89 25.5-6.76 19.93-6.76 19.93l1.86 10s8.7-5.57 11.15-18.07 0-21.61 0-21.61-7-28.08-6-31.08-4.14 15.33-4.14 15.33z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M635.64 510.02s1.52 8.78-16.38 4.9l-12 104.8s19.89-4.83 24.54-10.23 8.1-15.71 7-19.42-2.49-46.27-2.49-46.27z",
    fill: "#cd939c"
  }), React.createElement("path", {
    d: "M555.93 521.91s-35.81 67.43-16.72 82.67 54.84 20.31 67.11 15.24c0 0 5.68 1.52 4.83-16.21s6.59-67.22 6.59-67.22z",
    fill: "#cd939c"
  }), React.createElement("path", {
    d: "M557.12 524.92s-33.6 63.37-15.72 77.69 51.55 19.08 63.07 14.32c0 0 5.34 1.43 4.54-15.24s6.19-63.16 6.19-63.16z",
    fill: "#f6c6cd"
  }), React.createElement("path", {
    d: "M634.88 551.02c-1.38 1-9.25-1.4-9.25-1.4-8.51-.59-5.48-15.25-3.94-21.08.39-1.45.68-2.35.68-2.35 4 5.07 11.12 2.91 11.12 2.91s.21 1.63.49 4c.73 6.16 1.89 17.23.9 17.92z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M635.13 550.54c-1.37 1-9.24-1.39-9.24-1.39-8.52-.6-5.49-15.26-3.94-21.08.38-1.45.67-2.36.67-2.36 4 5.08 11.12 2.92 11.12 2.92s.21 1.63.5 4c.72 6.12 1.88 17.19.89 17.91z",
    fill: "#f6c6cd"
  }), React.createElement("path", {
    d: "M635.13 550.9c-1.37 1-9.24-1.39-9.24-1.39-8.52-.6-5.49-15.25-3.94-21.08.38-1.45.67-2.35.67-2.35 4 5.07 11.12 2.91 11.12 2.91s.21 1.63.5 4c.72 6.13 1.88 17.19.89 17.91z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M634.24 532.63c-3.88-.49-9.83-3.32-12.29-4.56.38-1.45.67-2.36.67-2.36 4 5.08 11.12 2.92 11.12 2.92s.21 1.63.5 4z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M630.45 528.02s-9.67 25.2 6.58 22.29c0 0 7.64-.8 7.6-6.59s-1.9-18.53-1.9-18.53z",
    fill: "#f6c6cd"
  }), React.createElement("path", {
    d: "M623.23 521.73s-4.92 20.41 10.83 12.84 5.67-12.84 5.67-12.84l-7.52-4.91z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M623.23 521.48s-4.92 20.4 10.83 12.83 5.67-12.83 5.67-12.83l-7.52-4.91z",
    fill: "#cd939c"
  }), React.createElement("path", {
    d: "M626.24 518.63s-4.51 1.2-2.2 5.66a12.85 12.85 0 0 1 1.45 6.55 3 3 0 0 0 2.47 3.18c1.62.29 3.93-.11 6.85-2.66 0 0 5.82-2.17 5.37-5s-10-9.19-10-9.19z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M626.24 518.37s-4.51 1.21-2.2 5.67a12.85 12.85 0 0 1 1.45 6.55 3 3 0 0 0 2.47 3.18c1.62.28 3.93-.12 6.85-2.66 0 0 5.82-2.18 5.37-5s-10-9.19-10-9.19z",
    fill: "#f6c6cd"
  }), React.createElement("circle", {
    cx: 632.31,
    cy: 525.63,
    r: 2.97,
    opacity: 0.1
  }), React.createElement("circle", {
    cx: 632.31,
    cy: 525.38,
    r: 2.97,
    fill: "#cd939c"
  }), React.createElement("path", {
    d: "M596.01 496.86s-28.27-3.5-29.71-2.42c0 0-15 2.56-15 30.55 0 0-.31 16.08 30.62 23.82 0 0 24.82 2.18 32.92-7.66s4.08-26.39 4.08-26.39 3.23-12.65 18.23-3.9c0 0 1.57-5-5.2-7.4s-35.94-6.6-35.94-6.6z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M596.01 496.36s-28.27-3.5-29.71-2.43c0 0-15 2.56-15 30.55 0 0-.31 16.09 30.62 23.83 0 0 24.82 2.18 32.92-7.66s4.08-26.39 4.08-26.39 3.23-12.65 18.23-3.91c0 0 1.57-5-5.2-7.4s-35.94-6.59-35.94-6.59z",
    fill: "#cd939c"
  }), React.createElement("path", {
    d: "M596.88 496.45s-27.48-3.29-28.88-2.28c0 0-14.56 2.41-14.56 28.76 0 0-.3 15.13 29.76 22.42 0 0 24.13 2 32-7.21s4-24.84 4-24.84 3.14-11.91 17.72-3.67c0 0 1.54-4.69-5-7s-35.04-6.18-35.04-6.18z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M596.88 496.2s-27.48-3.29-28.88-2.28c0 0-14.56 2.41-14.56 28.75 0 0-.3 15.14 29.76 22.42 0 0 24.13 2 32-7.21s4-24.83 4-24.83 3.14-11.91 17.72-3.68c0 0 1.54-4.68-5-7s-35.04-6.17-35.04-6.17z",
    fill: "#f6c6cd"
  }), React.createElement("path", {
    d: "M583.07 539.51s-7.47-3.41-7.85 3c0 0-2.53 6.46-2.66 7.22s.38 7.34 6.21 7.09a9 9 0 0 0 7.85-4.8s1.27-7.08 3-8.6-1.27-3-2.41-3a24.47 24.47 0 0 1-4.14-.91z",
    fill: "#cd939c"
  }), React.createElement("path", {
    d: "M582.06 538.5s-7.47-3.41-7.85 3c0 0-2.53 6.46-2.66 7.22s.38 7.34 6.21 7.09a9 9 0 0 0 7.85-4.82s1.26-7.09 3-8.61-1.27-3-2.41-3a24.71 24.71 0 0 1-4.14-.88z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M582.31 538.25s-7.47-3.42-7.85 3c0 0-2.53 6.46-2.66 7.22s.38 7.35 6.21 7.1a9 9 0 0 0 7.85-4.83s1.27-7.08 3-8.6-1.27-3-2.41-3a24.71 24.71 0 0 1-4.14-.89z",
    fill: "#f6c6cd"
  }), React.createElement("circle", {
    cx: 578.58,
    cy: 550.81,
    r: 2.71,
    opacity: 0.1
  }), React.createElement("circle", {
    cx: 578.58,
    cy: 550.56,
    r: 2.71,
    fill: "#cd939c"
  }), React.createElement("path", {
    d: "M603.91 565.36s-29.45-3.43-50-14c0 0-16.21 40.86-3.29 46.58s39.77 14.87 47.3 11.71c0 0 4.5.74 3-14.13s2.99-30.16 2.99-30.16z",
    fill: "#cd939c"
  }), React.createElement("path", {
    d: "M602.14 568.27s-29.45-3.23-50-13.17c0 0-16.22 38.44-3.3 43.82s39.77 14 47.31 11c0 0 4.5.7 3-13.3s2.99-28.35 2.99-28.35z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M602.64 568.02s-29.44-3.23-50-13.17c0 0-16.21 38.44-3.29 43.82s39.77 14 47.31 11c0 0 4.49.7 3-13.3s2.98-28.35 2.98-28.35z",
    fill: "#f6c6cd"
  }), React.createElement("g", {
    opacity: 0.1
  }, React.createElement("path", {
    d: "M631.84 502.2c-6.59-2.28-35-6.2-35-6.2s-27.48-3.3-28.88-2.28c0 0-7.1 1.17-11.38 10.85 4.31-8.69 10.88-9.78 10.88-9.78 1.39-1 28.88 2.28 28.88 2.28s28.37 3.93 35 6.21c4.42 1.53 5.18 4.14 5.2 5.7l.35.19s1.54-4.69-5.05-6.97zM619.42 512.13a8.67 8.67 0 0 0-.75 1.79s2.79 11.1-1.15 20.18c4.63-9.2 1.61-21.26 1.61-21.26s.12-.27.29-.71z"
  })));
};

UndrawExploring.propTypes = {
  height: PropTypes.string,
  primaryColor: PropTypes.string
};
export default UndrawExploring;